import { render } from "./MessagePart.vue?vue&type=template&id=452d6a23"
import script from "./MessagePart.vue?vue&type=script&lang=js"
export * from "./MessagePart.vue?vue&type=script&lang=js"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__